import { render, staticRenderFns } from "./MainDeposit.vue?vue&type=template&id=3e16134a&scoped=true&"
import script from "./MainDeposit.vue?vue&type=script&lang=ts&"
export * from "./MainDeposit.vue?vue&type=script&lang=ts&"
import style0 from "./MainDeposit.vue?vue&type=style&index=0&id=3e16134a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../namtrung_logistics/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e16134a",
  null
  
)

export default component.exports